import { useActivityCountQuery } from '@platform/state/api';
import type { IChangesWeek } from './IChangesWeek';

/**
 * «Зміни · 7 днів» огляду адміністрування (прототип v4: усі події історії простору за тиждень, точне число): лічильник сервера
 * GET /workspaces/{id}/activity/count?days=7. count: undefined — ще вантажиться, null — сервер не має лічильника (помилка запиту).
 */
export function useChangesWeek(ws: string): IChangesWeek {
  const { data, error } = useActivityCountQuery({ ws, days: 7 }, { skip: !ws });
  if (data) return { count: String(data.count) };
  return { count: error ? null : undefined };
}
